import Subastas from "./Subastas";

export default Subastas;